import { kind as disableKind } from '../../actions/goals/Disable';
import { kind as restart } from '../../actions/goals/Restart';
import { kind as start } from '../../actions/goals/Start';
import { reject, rejectAll, resolve } from '../../GoalResolvers';
import { State } from '../../State';
import { clean } from './clean';
import { destroy } from './destroy';
import { idle } from './idle';
import { suspend } from './suspend';

export function disable(state: State): State {
  const reason = 'Disabled';
  let goalResolvers = state.goalResolvers;
  goalResolvers = reject(goalResolvers, restart, reason);
  goalResolvers = reject(goalResolvers, start, reason);

  if (goalResolvers.Rebuild.length) {
    return clean({ ...state, disabled: true, goalResolvers });
  }

  if (goalResolvers.Destroy.length) {
    return destroy({ ...state, disabled: true, goalResolvers });
  }

  if (state.replication) {
    return suspend({ ...state, disabled: true, goalResolvers });
  }

  goalResolvers = resolve(goalResolvers, disableKind);
  goalResolvers = rejectAll(goalResolvers, reason);

  return idle({ ...state, disabled: true, goalResolvers });
}
